/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback, useRef } from 'react';
import type { Metric } from '../../types.tsx';

export type StopMetric = (
	additionalCustomData?: Record<string, string | number | boolean> | undefined,
) => void;

type StartMetric = (preloadTime: number | undefined) => void;

type UseMetricLogger = {
	startMetric: StartMetric;
	stopMetric: StopMetric;
};

export const useMetricLogger = (metric?: Metric): UseMetricLogger => {
	const preloadStartTime = useRef<number>(0);
	const loadStartTime = useRef<number>(0);

	const startMetric = useCallback(
		(preloadTime: number | undefined = 0) => {
			if (metric) {
				metric.start();
				preloadStartTime.current = preloadTime;
				loadStartTime.current = Date.now();
			}
		},
		[metric],
	);

	const stopMetric = useCallback(
		(additionalCustomData: Record<string, string | number | boolean> | undefined = undefined) => {
			if (metric) {
				const preloadData =
					preloadStartTime.current > 0
						? {
								preloadToStartDuration: loadStartTime.current - preloadStartTime.current,
							}
						: undefined;

				const metricData =
					preloadData || additionalCustomData
						? {
								customData: {
									...preloadData,
									...additionalCustomData,
								},
							}
						: undefined;

				metric.stop(metricData);
			}
		},
		[metric],
	);

	return { startMetric, stopMetric };
};
